import { Slugs } from 'common/urls/Slugs';
import QueryString from 'query-string';
import { useContext } from 'react';
import { useHistory } from 'react-router';
import { useMealPlanSurfacingLogic } from 'src/pages/consumer/meal-plans/hooks/useMealPlanSurfacingLogic';
import { MEAL_PLANS_INTAKE_FIRST_STEP } from 'src/pages/consumer/meal-plans/meal-plan-intake/preferences/consts';
import { MealPlanSubscriptionContext } from 'src/pages/consumer/meal-plans/MealPlanSubscriptionsContext';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { Routes } from 'src/shared/Routes';
import { getToken } from 'src/shared/storage/Storage';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';

export const useHomepageRedirects = ({ exploreQueryParams }) => {
  const { location } = useHistory();
  const token = getToken();
  const history = useHistory();
  const [cachedZipCode, , zipCodeMetaData] = useCachedZipCode();
  const [currentUser, currentUserLoading] = useCurrentUser();
  const { mealPlanDataLoaded } = useContext(MealPlanSubscriptionContext);
  const subscriptionLoaded = mealPlanDataLoaded || !currentUser;
  const dataLoaded = !currentUserLoading && subscriptionLoaded;

  const { mealPlanUrl, mealPlanIntakeRouteByRegion, setMealPlanHasBeenRedirected, mealPlanHasBeenRedirected } =
    useMealPlanSurfacingLogic();

  const shouldRedirectToExplore =
    Boolean(
      token && currentUser && currentUser.lastSearchedZipCode && currentUser.lastSearchedZipCodeIsAvailableToCustomers
    ) || Boolean(cachedZipCode && zipCodeMetaData?.cachedZipCodeData?.zipCode?.availableToCustomers);

  // 10/17/24, our new homepage renders before mealPlanDataLoaded. This leads to a pageview on shef.com
  //  right before a redirect, which gives us bad data. This if should redirect on home for those users.
  if (currentUser?.hasActiveMealPlan && !mealPlanHasBeenRedirected) {
    setMealPlanHasBeenRedirected();
    const path = getSluggedPath(Routes.CONSUMER_MEAL_PLANS_UPCOMING_ORDER, [], {
      ...QueryString.parse(location.search),
      ...exploreQueryParams,
    });
    history.push(path);
  }

  if (!dataLoaded) {
    return;
  }

  if (mealPlanUrl && mealPlanIntakeRouteByRegion) {
    let intakeQueryParams = {};

    if (mealPlanUrl?.includes(MEAL_PLANS_INTAKE_FIRST_STEP)) {
      setMealPlanHasBeenRedirected();
      // Extract possible query params from the route mealPlanIntakeRouteByRegion
      const paramsIndex = mealPlanIntakeRouteByRegion.indexOf('?');
      if (paramsIndex !== -1) {
        const existingQueryString = mealPlanIntakeRouteByRegion.substring(paramsIndex + 1);
        intakeQueryParams = QueryString.parse(existingQueryString);
      }
    }

    const path = getSluggedPath(mealPlanUrl, [], {
      ...QueryString.parse(location.search),
      ...exploreQueryParams,
      ...intakeQueryParams,
    });

    history.push(path);
    return;
  }

  if (shouldRedirectToExplore) {
    history.push(
      getSluggedPath(
        Routes.CONSUMER_EXPLORE,
        [
          {
            slug: Slugs.ZIP_CODE,
            value: currentUser?.lastSearchedZipCode ?? cachedZipCode ?? '',
          },
        ],
        { ...QueryString.parse(location.search), ...exploreQueryParams }
      )
    );
  }
};
